import { IconName } from "@/assets/icons"

import { stripNonNumerics } from "./normalizers"

export const US_LOCALE = "en-US"
// TODO: unify into one countries object.
// Gipptied, be careful when enabling these
export const LANGUAGE_NAMES = {
  aa: "Afaraf",
  ab: "аҧсуа",
  ae: "avesta", // (Avestan)
  af: "Afrikaans",
  ak: "Akan",
  am: "አማርኛ",
  an: "aragonés",
  ar: "العربية",
  as: "অসমীয়া",
  av: "авар",
  ay: "aymar aru",
  az: "azərbaycan dili",
  ba: "башҡортса",
  be: "Беларуская",
  bg: "български",
  bh: "भोजपुरी",
  bi: "Bislama",
  bm: "bamanankan",
  bn: "বাংলা",
  bo: "བོད་སྐད་",
  br: "brezhoneg",
  bs: "bosanski",
  ca: "català",
  ce: "нохчийн мотт",
  ch: "Chamoru",
  co: "corsu",
  cr: "Nehiyaw",
  cs: "čeština",
  cu: "ѩзыкъ словѣньскъ", // (Church Slavonic)
  cv: "чӑваш чӗлхи",
  cy: "Cymraeg",
  da: "dansk",
  de: "Deutsch",
  dv: "ދިވެހި",
  dz: "རྫོང་ཁ",
  ee: "Eʋegbe",
  el: "ελληνικά",
  en: "English",
  eo: "Esperanto",
  es: "español",
  et: "eesti",
  eu: "euskara",
  fa: "فارسی",
  ff: "pulaar", // or Fulfulde variants
  fi: "suomi",
  fj: "vosa Vakaviti",
  fo: "føroyskt",
  fr: "français",
  fy: "Frysk",
  ga: "Gaeilge",
  gd: "Gàidhlig",
  gl: "galego",
  gn: "Avañe'ẽ",
  gu: "ગુજરાતી",
  gv: "Gaelg",
  ha: "Hausa", // Often used in Latin; some communities also use Arabic script
  he: "עברית",
  hi: "हिन्दी",
  ho: "Hiri Motu",
  hr: "hrvatski",
  ht: "Kreyòl ayisyen",
  hu: "magyar",
  hy: "հայերեն",
  hz: "Otjiherero",
  ia: "Interlingua",
  id: "Bahasa Indonesia",
  ie: "Interlingue",
  ig: "Asụsụ Igbo",
  ii: "ꆈꌠ꒿ Nuosuhxop",
  ik: "Iñupiaq",
  io: "Ido",
  is: "íslenska",
  it: "italiano",
  iu: "ᐃᓄᒃᑎᑐᑦ",
  ja: "日本語",
  jv: "basa Jawa",
  ka: "ქართული",
  kg: "kiKongo",
  ki: "Gikuyu",
  kj: "Kuanyama",
  kk: "қазақ тілі",
  kl: "kalaallisut",
  km: "ភាសាខ្មែរ",
  kn: "ಕನ್ನಡ",
  ko: "한국어",
  kr: "Kanuri",
  ks: "کٲشُر", // Kashmiri (in Perso-Arabic script)
  ku: "Kurdî",
  kv: "коми кыв",
  kw: "Kernewek",
  ky: "Кыргызча",
  la: "latina",
  lb: "Lëtzebuergesch",
  lg: "Luganda",
  li: "Limburgs",
  ln: "lingála",
  lo: "ພາສາລາວ",
  lt: "lietuvių",
  lu: "Tshiluba",
  lv: "latviešu",
  mg: "fiteny malagasy",
  mh: "Kajin M̧ajeļ",
  mi: "te reo Māori",
  mk: "македонски",
  ml: "മലയാളം",
  mn: "монгол",
  mr: "मराठी",
  ms: "Bahasa Melayu",
  mt: "Malti",
  my: "ဗမာစာ",
  na: "Ekakairũ Naoero",
  nb: "norsk bokmål",
  nd: "isiNdebele",
  ne: "नेपाली",
  ng: "Ndonga",
  nl: "Nederlands",
  nn: "nynorsk",
  no: "norsk",
  nr: "isiNdebele",
  nv: "Diné bizaad",
  ny: "chiCheŵa",
  oc: "lenga d'òc",
  oj: "ᐊᓂᔑᓈᐯᒧᐎᓐ",
  om: "Afaan Oromoo",
  or: "ଓଡ଼ିଆ",
  os: "ирон æвзаг",
  pa: "ਪੰਜਾਬੀ",
  pi: "पाळि",
  pl: "polski",
  ps: "پښتو",
  pt: "português",
  qu: "Runa Simi",
  rm: "rumantsch",
  rn: "Ikirundi",
  ro: "română",
  ru: "русский",
  rw: "Kinyarwanda",
  sa: "संस्कृतम्",
  sc: "sardu",
  sd: "سنڌي",
  se: "Davvisámegiella",
  sg: "yângâ tî sängö",
  si: "සිංහල",
  sk: "slovenčina",
  sl: "slovenščina",
  sm: "gagana fa'a Samoa",
  sn: "chiShona",
  so: "Soomaaliga",
  sq: "shqip",
  sr: "српски",
  ss: "SiSwati",
  st: "Sesotho",
  su: "Basa Sunda",
  sv: "svenska",
  sw: "Kiswahili",
  ta: "தமிழ்",
  te: "తెలుగు",
  tg: "тоҷикӣ",
  th: "ไทย",
  ti: "ትግርኛ",
  tk: "Türkmençe",
  tl: "Tagalog",
  tn: "Setswana",
  to: "faka Tonga",
  tr: "Türkçe",
  ts: "Xitsonga",
  tt: "татарча",
  tw: "Twi",
  ty: "Reo Tahiti",
  ug: "ئۇيغۇرچە",
  uk: "українська",
  ur: "اردو",
  uz: "oʻzbek",
  ve: "Tshivenḓa",
  vi: "Tiếng Việt",
  vo: "Volapük",
  wa: "walon",
  wo: "Wolof",
  xh: "isiXhosa",
  yi: "ייִדיש",
  yo: "Èdè Yorùbá",
  za: "Saɯ-cəŋƅ", // approximate local name for Zhuang
  zh: "中文",
  zu: "isiZulu",
} as const

//export const SUPPORTED_LANGUAGES: readonly (keyof typeof LANGUAGE_NAMES)[] = ["en", "es"] as const;

function defineSupportedLanguages<
  T extends readonly (keyof typeof LANGUAGE_NAMES)[],
>(langs: T): T {
  return langs
}

export const SUPPORTED_LANGUAGES = defineSupportedLanguages([
  "en",
  "es",
] as const)

export const COUNTRY_IDENTIFIERS = [
  "AX",
  "AF",
  "AL",
  "DZ",
  "AD",
  "AO",
  "AG",
  "AR",
  "AM",
  "AU",
  "AT",
  "AZ",
  "BS",
  "BH",
  "BD",
  "BB",
  "BY",
  "BE",
  "BZ",
  "BJ",
  "BT",
  "BO",
  "BA",
  "BW",
  "BR",
  "VG",
  "BN",
  "BG",
  "BF",
  "BI",
  "KH",
  "CM",
  "CA",
  "CV",
  "KY",
  "CF",
  "TD",
  "CL",
  "CN",
  "CO",
  "KM",
  "CR",
  "HR",
  "CU",
  "CY",
  "CZ",
  "CD",
  "DK",
  "DJ",
  "DM",
  "DO",
  "TL",
  "EC",
  "EG",
  "SV",
  "GQ",
  "ER",
  "EE",
  "ET",
  "FK",
  "FO",
  "FJ",
  "FI",
  "FR",
  "GF",
  "GA",
  "GM",
  "GE",
  "DE",
  "GH",
  "GI",
  "GR",
  "GD",
  "GP",
  "GT",
  "GG",
  "GN",
  "GY",
  "HT",
  "HN",
  "HK",
  "HU",
  "IS",
  "IN",
  "ID",
  "IR",
  "IQ",
  "IE",
  "IM",
  "IL",
  "IT",
  "CI",
  "JM",
  "JP",
  "JE",
  "JO",
  "KZ",
  "KE",
  "KI",
  "XK",
  "KW",
  "KG",
  "LA",
  "LV",
  "LB",
  "LS",
  "LR",
  "LY",
  "LI",
  "LT",
  "LU",
  "MG",
  "MW",
  "MY",
  "MV",
  "ML",
  "MT",
  "MH",
  "MR",
  "MU",
  "MX",
  "FM",
  "MD",
  "MC",
  "MN",
  "ME",
  "MA",
  "MZ",
  "MM",
  "NA",
  "NR",
  "NP",
  "NL",
  "NZ",
  "NI",
  "NE",
  "NG",
  "KP",
  "MK",
  "NO",
  "OM",
  "PK",
  "PW",
  "PS",
  "PA",
  "PG",
  "PY",
  "PE",
  "PH",
  "PL",
  "PT",
  "PR",
  "QA",
  "CG",
  "RO",
  "RU",
  "RW",
  "KN",
  "LC",
  "VC",
  "WS",
  "SM",
  "ST",
  "SA",
  "SN",
  "RS",
  "SC",
  "SL",
  "SG",
  "SK",
  "SI",
  "SB",
  "SO",
  "ZA",
  "GS",
  "KR",
  "SS",
  "ES",
  "LK",
  "SD",
  "SR",
  "SE",
  "CH",
  "SY",
  "TW",
  "TJ",
  "TZ",
  "TH",
  "TG",
  "TO",
  "TT",
  "TN",
  "TR",
  "TM",
  "UG",
  "UA",
  "AE",
  "GB",
  "US",
  "UY",
  "UZ",
  "VE",
  "VN",
  "YE",
  "ZM",
  "ZW",
] as const

export type CountryIdentifiers = (typeof COUNTRY_IDENTIFIERS)[number]

export const COUNTRIES = new Map<CountryIdentifiers, string>([
  ["AX", "Åland Islands"],
  ["AF", "Afghanistan"],
  ["AL", "Albania"],
  ["DZ", "Algeria"],
  ["AD", "Andorra"],
  ["AO", "Angola"],
  ["AG", "Antigua and Barbuda"],
  ["AR", "Argentina"],
  ["AM", "Armenia"],
  ["AU", "Australia"],
  ["AT", "Austria"],
  ["AZ", "Azerbaijan"],
  ["BS", "Bahamas"],
  ["BH", "Bahrain"],
  ["BD", "Bangladesh"],
  ["BB", "Barbados"],
  ["BY", "Belarus"],
  ["BE", "Belgium"],
  ["BZ", "Belize"],
  ["BJ", "Benin"],
  ["BT", "Bhutan"],
  ["BO", "Bolivia"],
  ["BA", "Bosnia and Herzegovina"],
  ["BW", "Botswana"],
  ["BR", "Brazil"],
  ["VG", "British Virgin Islands"],
  ["BN", "Brunei"],
  ["BG", "Bulgaria"],
  ["BF", "Burkina Faso"],
  ["BI", "Burundi"],
  ["KH", "Cambodia"],
  ["CM", "Cameroon"],
  ["CA", "Canada"],
  ["CV", "Cape Verde"],
  ["KY", "Cayman Islands"],
  ["CF", "Central African Republic"],
  ["TD", "Chad"],
  ["CL", "Chile"],
  ["CN", "China"],
  ["CO", "Colombia"],
  ["KM", "Comoros"],
  ["CR", "Costa Rica"],
  ["HR", "Croatia"],
  ["CU", "Cuba"],
  ["CY", "Cyprus"],
  ["CZ", "Czech Republic"],
  ["CD", "Democratic Republic of the Congo"],
  ["DK", "Denmark"],
  ["DJ", "Djibouti"],
  ["DM", "Dominica"],
  ["DO", "Dominican Republic"],
  ["TL", "East Timor"],
  ["EC", "Ecuador"],
  ["EG", "Egypt"],
  ["SV", "El Salvador"],
  ["GQ", "Equatorial Guinea"],
  ["ER", "Eritrea"],
  ["EE", "Estonia"],
  ["ET", "Ethiopia"],
  ["FK", "Falkland Islands"],
  ["FO", "Faroe Islands"],
  ["FJ", "Fiji"],
  ["FI", "Finland"],
  ["FR", "France"],
  ["GF", "French Guiana"],
  ["GA", "Gabon"],
  ["GM", "Gambia"],
  ["GE", "Georgia"],
  ["DE", "Germany"],
  ["GH", "Ghana"],
  ["GI", "Gibraltar"],
  ["GR", "Greece"],
  ["GD", "Grenada"],
  ["GP", "Guadeloupe"],
  ["GT", "Guatemala"],
  ["GG", "Guernsey"],
  ["GN", "Guinea"],
  ["GY", "Guyana"],
  ["HT", "Haiti"],
  ["HN", "Honduras"],
  ["HK", "Hong Kong"],
  ["HU", "Hungary"],
  ["IS", "Iceland"],
  ["IN", "India"],
  ["ID", "Indonesia"],
  ["IR", "Iran"],
  ["IQ", "Iraq"],
  ["IE", "Ireland"],
  ["IM", "Isle of Man"],
  ["IL", "Israel"],
  ["IT", "Italy"],
  ["CI", "Ivory Coast"],
  ["JM", "Jamaica"],
  ["JP", "Japan"],
  ["JE", "Jersey"],
  ["JO", "Jordan"],
  ["KZ", "Kazakhstan"],
  ["KE", "Kenya"],
  ["KI", "Kiribati"],
  ["XK", "Kosovo"],
  ["KW", "Kuwait"],
  ["KG", "Kyrgyzstan"],
  ["LA", "Laos"],
  ["LV", "Latvia"],
  ["LB", "Lebanon"],
  ["LS", "Lesotho"],
  ["LR", "Liberia"],
  ["LY", "Libya"],
  ["LI", "Liechtenstein"],
  ["LT", "Lithuania"],
  ["LU", "Luxembourg"],
  ["MG", "Madagascar"],
  ["MW", "Malawi"],
  ["MY", "Malaysia"],
  ["MV", "Maldives"],
  ["ML", "Mali"],
  ["MT", "Malta"],
  ["MH", "Marshall Islands"],
  ["MR", "Mauritania"],
  ["MU", "Mauritius"],
  ["MX", "Mexico"],
  ["FM", "Micronesia"],
  ["MD", "Moldova"],
  ["MC", "Monaco"],
  ["MN", "Mongolia"],
  ["ME", "Montenegro"],
  ["MA", "Morocco"],
  ["MZ", "Mozambique"],
  ["MM", "Myanmar"],
  ["NA", "Namibia"],
  ["NR", "Nauru"],
  ["NP", "Nepal"],
  ["NL", "Netherlands"],
  ["NZ", "New Zealand"],
  ["NI", "Nicaragua"],
  ["NE", "Niger"],
  ["NG", "Nigeria"],
  ["KP", "North Korea"],
  ["MK", "North Macedonia"],
  ["NO", "Norway"],
  ["OM", "Oman"],
  ["PK", "Pakistan"],
  ["PW", "Palau"],
  ["PS", "Palestine"],
  ["PA", "Panama"],
  ["PG", "Papua New Guinea"],
  ["PY", "Paraguay"],
  ["PE", "Peru"],
  ["PH", "Philippines"],
  ["PL", "Poland"],
  ["PT", "Portugal"],
  ["PR", "Puerto Rico"],
  ["QA", "Qatar"],
  ["CG", "Republic of the Congo"],
  ["RO", "Romania"],
  ["RU", "Russia"],
  ["RW", "Rwanda"],
  ["KN", "Saint Kitts and Nevis"],
  ["LC", "Saint Lucia"],
  ["VC", "Saint Vincent and the Grenadines"],
  ["WS", "Samoa"],
  ["SM", "San Marino"],
  ["ST", "Sao Tome and Principe"],
  ["SA", "Saudi Arabia"],
  ["SN", "Senegal"],
  ["RS", "Serbia"],
  ["SC", "Seychelles"],
  ["SL", "Sierra Leone"],
  ["SG", "Singapore"],
  ["SK", "Slovakia"],
  ["SI", "Slovenia"],
  ["SB", "Solomon Islands"],
  ["SO", "Somalia"],
  ["ZA", "South Africa"],
  ["GS", "South Georgia and the South Sandwich Islands"],
  ["KR", "South Korea"],
  ["SS", "South Sudan"],
  ["ES", "Spain"],
  ["LK", "Sri Lanka"],
  ["SD", "Sudan"],
  ["SR", "Suriname"],
  ["SE", "Sweden"],
  ["CH", "Switzerland"],
  ["SY", "Syria"],
  ["TW", "Taiwan"],
  ["TJ", "Tajikistan"],
  ["TZ", "Tanzania"],
  ["TH", "Thailand"],
  ["TG", "Togo"],
  ["TO", "Tonga"],
  ["TT", "Trinidad and Tobago"],
  ["TN", "Tunisia"],
  ["TR", "Turkey"],
  ["TM", "Turkmenistan"],
  ["UG", "Uganda"],
  ["UA", "Ukraine"],
  ["AE", "United Arab Emirates"],
  ["GB", "United Kingdom"],
  ["US", "United States"],
  ["UY", "Uruguay"],
  ["UZ", "Uzbekistan"],
  ["VE", "Venezuela"],
  ["VN", "Vietnam"],
  ["YE", "Yemen"],
  ["ZM", "Zambia"],
  ["ZW", "Zimbabwe"],
])

export const COUNTRY_ICONS = new Map<CountryIdentifiers, IconName>([
  ["AX", "flagAalandIslands"],
  ["AF", "flagAfghanistan"],
  ["AL", "flagAlbania"],
  ["DZ", "flagAlgeria"],
  ["AD", "flagAndorra"],
  ["AO", "flagAngola"],
  ["AG", "flagAntiguaBarbuda"],
  ["AR", "flagArgentina"],
  ["AM", "flagArmenia"],
  ["AU", "flagAustralia"],
  ["AT", "flagAustria"],
  ["AZ", "flagAzerbaijan"],
  ["BS", "flagBahamas"],
  ["BH", "flagBahrain"],
  ["BD", "flagBangladesh"],
  ["BB", "flagBarbados"],
  ["BY", "flagBelarus"],
  ["BE", "flagBelgium"],
  ["BZ", "flagBelize"],
  ["BJ", "flagBenin"],
  ["BT", "flagBhutan"],
  ["BO", "flagBolivia"],
  ["BA", "flagBosniaHerzegovina"],
  ["BW", "flagBotswana"],
  ["BR", "flagBrazil"],
  ["VG", "flagBritishVirginIslands"],
  ["BN", "flagBrunei"],
  ["BG", "flagBulgaria"],
  ["BF", "flagBurkinaFaso"],
  ["BI", "flagBurundi"],
  ["KH", "flagCambodia"],
  ["CM", "flagCameroon"],
  ["CA", "flagCanada"],
  ["CV", "flagCapeVerde"],
  ["KY", "flagCaymanIslands"],
  ["CF", "flagCentralAfricanRepublic"],
  ["TD", "flagChad"],
  ["CL", "flagChile"],
  ["CN", "flagChina"],
  ["CO", "flagColombia"],
  ["KM", "flagComoros"],
  ["CR", "flagCostaRica"],
  ["HR", "flagCroatia"],
  ["CU", "flagCuba"],
  ["CY", "flagCyprus"],
  ["CZ", "flagCzechia"],
  ["CD", "flagDemocraticRepublicCongo"],
  ["DK", "flagDenmark"],
  ["DJ", "flagDjibouti"],
  ["DM", "flagDominica"],
  ["DO", "flagDominicanRepublic"],
  ["TL", "flagEastTimor"],
  ["EC", "flagEcuador"],
  ["EG", "flagEgypt"],
  ["SV", "flagElSalvador"],
  ["GQ", "flagEquatorialGuinea"],
  ["ER", "flagEritrea"],
  ["EE", "flagEstonia"],
  ["ET", "flagEthiopia"],
  ["FK", "flagFalklandIslands"],
  ["FO", "flagFaroeIslands"],
  ["FJ", "flagFiji"],
  ["FI", "flagFinland"],
  ["FR", "flagFrance"],
  ["GF", "flagFrenchGuiana"],
  ["GA", "flagGabon"],
  ["GM", "flagGambia"],
  ["GE", "flagGeorgia"],
  ["DE", "flagGermany"],
  ["GH", "flagGhana"],
  ["GI", "flagGibraltar"],
  ["GR", "flagGreece"],
  ["GD", "flagGrenada"],
  ["GP", "flagGuadeloupe"],
  ["GT", "flagGuatemala"],
  ["GG", "flagGuernsey"],
  ["GN", "flagGuinea"],
  ["GY", "flagGuyana"],
  ["HT", "flagHaiti"],
  ["HN", "flagHonduras"],
  ["HK", "flagHongKong"],
  ["HU", "flagHungary"],
  ["IS", "flagIceland"],
  ["IN", "flagIndia"],
  ["ID", "flagIndonesia"],
  ["IR", "flagIran"],
  ["IQ", "flagIraq"],
  ["IE", "flagIreland"],
  ["IM", "flagIsleOfMan"],
  ["IL", "flagIsrael"],
  ["IT", "flagItaly"],
  ["CI", "flagIvoryCoast"],
  ["JM", "flagJamaica"],
  ["JP", "flagJapan"],
  ["JE", "flagJersey"],
  ["JO", "flagJordan"],
  ["KZ", "flagKazakhstan"],
  ["KE", "flagKenya"],
  ["KI", "flagKiribati"],
  ["XK", "flagKosovo"],
  ["KW", "flagKuwait"],
  ["KG", "flagKyrgyzstan"],
  ["LA", "flagLaos"],
  ["LV", "flagLatvia"],
  ["LB", "flagLebanon"],
  ["LS", "flagLesotho"],
  ["LR", "flagLiberia"],
  ["LY", "flagLibya"],
  ["LI", "flagLiechtenstein"],
  ["LT", "flagLithuania"],
  ["LU", "flagLuxembourg"],
  ["MG", "flagMadagascar"],
  ["MW", "flagMalawi"],
  ["MY", "flagMalaysia"],
  ["MV", "flagMaldives"],
  ["ML", "flagMali"],
  ["MT", "flagMalta"],
  ["MH", "flagMarshallIslands"],
  ["MR", "flagMauritania"],
  ["MU", "flagMauritius"],
  ["MX", "flagMexico"],
  ["FM", "flagMicronesia"],
  ["MD", "flagMoldova"],
  ["MC", "flagMonaco"],
  ["MN", "flagMongolia"],
  ["ME", "flagMontenegro"],
  ["MA", "flagMorocco"],
  ["MZ", "flagMozanbique"],
  ["MM", "flagMyanmar"],
  ["NA", "flagNamibia"],
  ["NR", "flagNauru"],
  ["NP", "flagNepal"],
  ["NL", "flagNetherlands"],
  ["NZ", "flagNewZealand"],
  ["NI", "flagNicaragua"],
  ["NE", "flagNiger"],
  ["NG", "flagNigeria"],
  ["KP", "flagNorthKorea"],
  ["MK", "flagNorthMacedonia"],
  ["NO", "flagNorway"],
  ["OM", "flagOman"],
  ["PK", "flagPakistan"],
  ["PW", "flagPalau"],
  ["PS", "flagPalestine"],
  ["PA", "flagPanama"],
  ["PG", "flagPapuaNewGuinea"],
  ["PY", "flagParaguay"],
  ["PE", "flagPeru"],
  ["PH", "flagPhilippines"],
  ["PL", "flagPoland"],
  ["PT", "flagPortugal"],
  ["PR", "flagPuertoRico"],
  ["QA", "flagQuatar"],
  ["CG", "flagRepublicCongo"],
  ["RO", "flagRomania"],
  ["RU", "flagRussia"],
  ["RW", "flagRwanda"],
  ["KN", "flagSaintKittsNevis"],
  ["LC", "flagSaintLucia"],
  ["VC", "flagSaintVincentGrenadines"],
  ["WS", "flagSamoa"],
  ["SM", "flagSanMarino"],
  ["ST", "flagSaoTomePrincipe"],
  ["SA", "flagSaudiArabia"],
  ["SN", "flagSenegal"],
  ["RS", "flagSerbia"],
  ["SC", "flagSeychelles"],
  ["SL", "flagSierraLeone"],
  ["SG", "flagSingapore"],
  ["SK", "flagSlovakia"],
  ["SI", "flagSlovenia"],
  ["SB", "flagSolomonIslands"],
  ["SO", "flagSomalia"],
  ["ZA", "flagSouthAfrica"],
  ["GS", "flagSouthGeorgiaSandwichIslands"],
  ["KR", "flagSouthKorea"],
  ["SS", "flagSouthSudan"],
  ["ES", "flagSpain"],
  ["LK", "flagSriLanka"],
  ["SD", "flagSudan"],
  ["SR", "flagSuriname"],
  ["SE", "flagSweden"],
  ["CH", "flagSwitzerland"],
  ["SY", "flagSyria"],
  ["TW", "flagTaiwan"],
  ["TJ", "flagTajikistan"],
  ["TZ", "flagTanzania"],
  ["TH", "flagThailand"],
  ["TG", "flagTogo"],
  ["TO", "flagTonga"],
  ["TT", "flagTrinidadTobago"],
  ["TN", "flagTunisia"],
  ["TR", "flagTurkey"],
  ["TM", "flagTurkmenistan"],
  ["UG", "flagUganda"],
  ["UA", "flagUkraine"],
  ["AE", "flagUnitedArabEmirates"],
  ["GB", "flagUnitedKingdom"],
  ["US", "flagUnitedStates"],
  ["UY", "flagUruguay"],
  ["UZ", "flagUzbekistan"],
  ["VE", "flagVenezuela"],
  ["VN", "flagVietnam"],
  ["YE", "flagYemen"],
  ["ZM", "flagZambia"],
  ["ZW", "flagZimbabwe"],
])

// Country dial codes for international phone numbers
export const COUNTRY_DIAL_CODES = new Map<CountryIdentifiers, string>([
  ["AX", "+358"],
  ["AF", "+93"],
  ["AL", "+355"],
  ["DZ", "+213"],
  ["AD", "+376"],
  ["AO", "+244"],
  ["AG", "+1"],
  ["AR", "+54"],
  ["AM", "+374"],
  ["AU", "+61"],
  ["AT", "+43"],
  ["AZ", "+994"],
  ["BS", "+1"],
  ["BH", "+973"],
  ["BD", "+880"],
  ["BB", "+1"],
  ["BY", "+375"],
  ["BE", "+32"],
  ["BZ", "+501"],
  ["BJ", "+229"],
  ["BT", "+975"],
  ["BO", "+591"],
  ["BA", "+387"],
  ["BW", "+267"],
  ["BR", "+55"],
  ["VG", "+1"],
  ["BN", "+673"],
  ["BG", "+359"],
  ["BF", "+226"],
  ["BI", "+257"],
  ["KH", "+855"],
  ["CM", "+237"],
  ["CA", "+1"],
  ["CV", "+238"],
  ["KY", "+1"],
  ["CF", "+236"],
  ["TD", "+235"],
  ["CL", "+56"],
  ["CN", "+86"],
  ["CO", "+57"],
  ["KM", "+269"],
  ["CR", "+506"],
  ["HR", "+385"],
  ["CU", "+53"],
  ["CY", "+357"],
  ["CZ", "+420"],
  ["CD", "+243"],
  ["DK", "+45"],
  ["DJ", "+253"],
  ["DM", "+1"],
  ["DO", "+1"],
  ["TL", "+670"],
  ["EC", "+593"],
  ["EG", "+20"],
  ["SV", "+503"],
  ["GQ", "+240"],
  ["ER", "+291"],
  ["EE", "+372"],
  ["ET", "+251"],
  ["FK", "+500"],
  ["FO", "+298"],
  ["FJ", "+679"],
  ["FI", "+358"],
  ["FR", "+33"],
  ["GF", "+594"],
  ["GA", "+241"],
  ["GM", "+220"],
  ["GE", "+995"],
  ["DE", "+49"],
  ["GH", "+233"],
  ["GI", "+350"],
  ["GR", "+30"],
  ["GD", "+1"],
  ["GP", "+590"],
  ["GT", "+502"],
  ["GG", "+44"],
  ["GN", "+224"],
  ["GY", "+592"],
  ["HT", "+509"],
  ["HN", "+504"],
  ["HK", "+852"],
  ["HU", "+36"],
  ["IS", "+354"],
  ["IN", "+91"],
  ["ID", "+62"],
  ["IR", "+98"],
  ["IQ", "+964"],
  ["IE", "+353"],
  ["IM", "+44"],
  ["IL", "+972"],
  ["IT", "+39"],
  ["CI", "+225"],
  ["JM", "+1"],
  ["JP", "+81"],
  ["JE", "+44"],
  ["JO", "+962"],
  ["KZ", "+7"],
  ["KE", "+254"],
  ["KI", "+686"],
  ["XK", "+383"],
  ["KW", "+965"],
  ["KG", "+996"],
  ["LA", "+856"],
  ["LV", "+371"],
  ["LB", "+961"],
  ["LS", "+266"],
  ["LR", "+231"],
  ["LY", "+218"],
  ["LI", "+423"],
  ["LT", "+370"],
  ["LU", "+352"],
  ["MG", "+261"],
  ["MW", "+265"],
  ["MY", "+60"],
  ["MV", "+960"],
  ["ML", "+223"],
  ["MT", "+356"],
  ["MH", "+692"],
  ["MR", "+222"],
  ["MU", "+230"],
  ["MX", "+52"],
  ["FM", "+691"],
  ["MD", "+373"],
  ["MC", "+377"],
  ["MN", "+976"],
  ["ME", "+382"],
  ["MA", "+212"],
  ["MZ", "+258"],
  ["MM", "+95"],
  ["NA", "+264"],
  ["NR", "+674"],
  ["NP", "+977"],
  ["NL", "+31"],
  ["NZ", "+64"],
  ["NI", "+505"],
  ["NE", "+227"],
  ["NG", "+234"],
  ["KP", "+850"],
  ["MK", "+389"],
  ["NO", "+47"],
  ["OM", "+968"],
  ["PK", "+92"],
  ["PW", "+680"],
  ["PS", "+970"],
  ["PA", "+507"],
  ["PG", "+675"],
  ["PY", "+595"],
  ["PE", "+51"],
  ["PH", "+63"],
  ["PL", "+48"],
  ["PT", "+351"],
  ["PR", "+1"],
  ["QA", "+974"],
  ["CG", "+242"],
  ["RO", "+40"],
  ["RU", "+7"],
  ["RW", "+250"],
  ["KN", "+1"],
  ["LC", "+1"],
  ["VC", "+1"],
  ["WS", "+685"],
  ["SM", "+378"],
  ["ST", "+239"],
  ["SA", "+966"],
  ["SN", "+221"],
  ["RS", "+381"],
  ["SC", "+248"],
  ["SL", "+232"],
  ["SG", "+65"],
  ["SK", "+421"],
  ["SI", "+386"],
  ["SB", "+677"],
  ["SO", "+252"],
  ["ZA", "+27"],
  ["GS", "+500"],
  ["KR", "+82"],
  ["SS", "+211"],
  ["ES", "+34"],
  ["LK", "+94"],
  ["SD", "+249"],
  ["SR", "+597"],
  ["SE", "+46"],
  ["CH", "+41"],
  ["SY", "+963"],
  ["TW", "+886"],
  ["TJ", "+992"],
  ["TZ", "+255"],
  ["TH", "+66"],
  ["TG", "+228"],
  ["TO", "+676"],
  ["TT", "+1"],
  ["TN", "+216"],
  ["TR", "+90"],
  ["TM", "+993"],
  ["UG", "+256"],
  ["UA", "+380"],
  ["AE", "+971"],
  ["GB", "+44"],
  ["US", "+1"],
  ["UY", "+598"],
  ["UZ", "+998"],
  ["VE", "+58"],
  ["VN", "+84"],
  ["YE", "+967"],
  ["ZM", "+260"],
  ["ZW", "+263"],
])

export interface CountryPhoneData {
  code: CountryIdentifiers
  name: string
  dialCode: string
  iconName?: IconName
}

export function getCountriesWithPhoneData(): CountryPhoneData[] {
  const countries: CountryPhoneData[] = []

  for (const [code, name] of COUNTRIES) {
    const dialCode = COUNTRY_DIAL_CODES.get(code)
    const iconName = COUNTRY_ICONS.get(code)

    if (dialCode) {
      countries.push({
        code,
        name,
        dialCode,
        iconName,
      })
    }
  }

  return countries.sort((a, b) => a.name.localeCompare(b.name))
}

export function getCountryPhoneData(
  code: CountryIdentifiers
): CountryPhoneData | undefined {
  const name = COUNTRIES.get(code)
  const dialCode = COUNTRY_DIAL_CODES.get(code)
  const iconName = COUNTRY_ICONS.get(code)

  if (name && dialCode) {
    return { code, name, dialCode, iconName }
  }
  return undefined
}

export function searchCountriesForPhone(query: string): CountryPhoneData[] {
  const lowerQuery = query.toLowerCase()
  return getCountriesWithPhoneData().filter(
    (country) =>
      country.name.toLowerCase().includes(lowerQuery) ||
      country.code.toLowerCase().includes(lowerQuery) ||
      country.dialCode.includes(query)
  )
}

type LanguageIdentifier = (typeof SUPPORTED_LANGUAGES)[number] | (string & {})

export function iconForLanguage(
  languageIdentifier?: LanguageIdentifier
): IconName {
  switch (languageIdentifier) {
    case "en":
      return COUNTRY_ICONS.get("US")!
    case "es":
      return COUNTRY_ICONS.get("MX")!
    default:
      return "translation"
  }
}

export function getLanguageName(languageIdentifier?: LanguageIdentifier) {
  if (languageIdentifier && languageIdentifier in LANGUAGE_NAMES) {
    return LANGUAGE_NAMES[languageIdentifier as keyof typeof LANGUAGE_NAMES]
  }
  return "English"
}

export function getCountryCodesFromPhoneNumber(
  phoneNumber: string
): CountryIdentifiers[] {
  // Normalize the phone number - remove spaces, dashes, parentheses
  const normalized = phoneNumber.replace(/[\s\-\(\)]/g, "")

  // Ensure it starts with + for consistent matching
  const withPlus = normalized.startsWith("+") ? normalized : `+${normalized}`

  // Get all unique dial codes and sort by length (longest first)
  const dialCodes = Array.from(new Set(COUNTRY_DIAL_CODES.values())).sort(
    (a, b) => b.length - a.length
  )

  // Find the matching dial code
  const matchingDialCode = dialCodes.find((code) => withPlus.startsWith(code))

  if (!matchingDialCode) {
    return []
  }

  // Find all countries with this dial code
  const matchingCountries: CountryIdentifiers[] = []
  for (const [country, code] of COUNTRY_DIAL_CODES.entries()) {
    if (code === matchingDialCode) {
      matchingCountries.push(country)
    }
  }

  return matchingCountries
}

// TODO fix me, we don't handle all the duplicate cases gracefully
export function getPrimaryCountryCodeFromPhoneNumber(
  phoneNumber: string
): CountryIdentifiers | null {
  const countries = getCountryCodesFromPhoneNumber(phoneNumber)

  if (!countries.length) return null

  if (countries.length === 1) {
    return countries[0]
  }

  /*
    This is where we are grabbing our info on area codes from
    https://en.wikipedia.org/wiki/List_of_telephone_country_codes
  */
  const dialCode = COUNTRY_DIAL_CODES.get(countries[0])!

  // +1 Country Code phone number
  if (dialCode === COUNTRY_DIAL_CODES.get("US")) {
    const areaCode = stripNonNumerics(phoneNumber).slice(
      dialCode.length - 1,
      dialCode.length + 2
    )

    /*
      TODO fix me, we don't have icons for all the country codes.
      Many of them are british or american overseas territories.
      We are defaulting to "US" in those cases
    */
    switch (areaCode) {
      case "268":
        return "AG" // Antigua and Barbuda
      case "264":
        return "US" // Anguilla
      case "684":
        return "US" // American Samoa
      case "246":
        return "BB" // Barbados
      case "441":
        return "US" // Bermuda
      case "242":
        return "BS" // Bahamas

      // Canada
      case "204": // Manitoba
      case "226": // Ontario
      case "236": // British Columbia
      case "249": // Ontario
      case "250": // British Columbia
      case "263": // Quebec
      case "289": // Ontario
      case "306": // Saskatchewan
      case "343": // Ontario
      case "354": // Quebec
      case "365": // Ontario
      case "367": // Quebec
      case "403": // Alberta
      case "416": // Ontario
      case "418": // Quebec
      case "428": // New Brunswick
      case "431": // Manitoba
      case "437": // Ontario
      case "438": // Quebec
      case "450": // Quebec
      case "468": // Sherbrooke, QC
      case "474": // Saskatchewan
      case "506": // New Brunswick
      case "514": // Quebec
      case "519": // Ontario
      case "548": // Ontario
      case "579": // Quebec
      case "581": // Quebec
      case "584": // Manitoba
      case "587": // Alberta
      case "604": // British Columbia
      case "613": // Ontario
      case "639": // Saskatchewan
      case "647": // Ontario
      case "672": // Vancouver, BC
      case "683": // Sudbury, ON
      case "705": // Ontario
      case "709": // Newfoundland and Labrador
      case "742": // Hamilton, ON
      case "753": // Ottawa, ON
      case "778": // British Columbia
      case "780": // Alberta
      case "782": // Nova Scotia & PEI
      case "807": // Ontario
      case "819": // Quebec
      case "825": // Alberta
      case "867": // Yukon, Northwest Territories, Nunavut
      case "873": // Quebec
      case "879": // Newfoundland/Labrador"
      case "902": // Nova Scotia & PEI
      case "905": // Ontario
        return "CA" // Maple Syrup
      case "767":
        return "DM" // Dominica
      case "809":
      case "829":
      case "849":
        return "DO" // Dominican Republic
      case "473":
        return "GD" // Grenada
      case "671":
        return "US" // Guam
      case "658":
      case "876":
        return "JM" // Jamaica
      case "869":
        return "KN" // Saint Kitts and Nevis
      case "345":
        return "KY" // Cayman Islands
      case "758":
        return "LC" // Saint Lucia
      case "670":
        return "US" // Northern Mariana Islands
      case "664":
        return "US" // Montserrat
      case "787":
      case "939":
        return "PR" // Puerto Rico
      case "721":
        return "US" // Sint Maarten
      case "649":
        return "US" // Turks and Caicos Islands
      case "868":
        return "TT" // Trinidad and Tobago
      case "784":
        return "VC" // St. Vincent & Grenadines
      case "284":
        return "VG" // British Virgin Islands
      case "340":
        return "US" // U.S. Virgin Islands
      default:
        // Return null or an empty string for any unlisted area code
        return "US"
    }
  }

  return countries[0]
}
